/** Generate by swagger-axios-codegen */
// @ts-nocheck
/* eslint-disable */

/** Generate by swagger-axios-codegen */
/* eslint-disable */
// @ts-nocheck
import axiosStatic, { type AxiosInstance, type AxiosRequestConfig } from 'axios';

export interface IRequestOptions extends AxiosRequestConfig {
  /**
   * show loading status
   */
  loading?: boolean;
  /**
   * display error message
   */
  showError?: boolean;
  /**
   * data security, extended fields are encrypted using the specified algorithm
   */
  security?: Record<string, 'md5' | 'sha1' | 'aes' | 'des'>;
  /**
   * indicates whether Authorization credentials are required for the request
   * @default true
   */
  withAuthorization?: boolean;
}

export interface IRequestConfig {
  method?: any;
  headers?: any;
  url?: any;
  data?: any;
  params?: any;
}

// Add options interface
export interface ServiceOptions {
  axios?: AxiosInstance;
  /** only in axios interceptor config*/
  loading: boolean;
  showError: boolean;
}

// Add default options
export const serviceOptions: ServiceOptions = {};

// Instance selector
export function axios(configs: IRequestConfig, resolve: (p: any) => void, reject: (p: any) => void): Promise<any> {
  if (serviceOptions.axios) {
    return serviceOptions.axios
      .request(configs)
      .then((res) => {
        resolve(res.data);
      })
      .catch((err) => {
        reject(err);
      });
  } else {
    throw new Error('please inject yourself instance like axios  ');
  }
}

export function getConfigs(method: string, contentType: string, url: string, options: any): IRequestConfig {
  const configs: IRequestConfig = {
    loading: serviceOptions.loading,
    showError: serviceOptions.showError,
    ...options,
    method,
    url
  };
  configs.headers = {
    ...options.headers,
    'Content-Type': contentType
  };
  return configs;
}

export const basePath = '';

export interface IList<T> extends Array<T> {}
export interface List<T> extends Array<T> {}
export interface IDictionary<TValue> {
  [key: string]: TValue;
}
export interface Dictionary<TValue> extends IDictionary<TValue> {}

export interface IListResult<T> {
  items?: T[];
}

export class ListResultDto<T> implements IListResult<T> {
  items?: T[];
}

export interface IPagedResult<T> extends IListResult<T> {
  totalCount?: number;
  items?: T[];
}

export class PagedResultDto<T = any> implements IPagedResult<T> {
  totalCount?: number;
  items?: T[];
}

// customer definition
// empty

export class RpcService {
  /**
   *
   */
  static callFunction(
    params: {
      /**  */
      count?: string;
      /** requestBody */
      body?: RpcCallFunctionDto;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/rpc/call-fn';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);
      configs.params = { count: params['count'] };

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static readWithRefs(
    params: {
      /**  */
      count?: string;
      /** requestBody */
      body?: RpcReadWithRefsDto;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/rpc/read-with-refs';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);
      configs.params = { count: params['count'] };

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static modify(
    params: {
      /** requestBody */
      body?: RpcModifyDto;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/rpc/modify';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static readLinkedData(
    params: {
      /** requestBody */
      body?: ReadLinkedDataDto;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<ReadLinkedDataResponse[]> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/rpc/read-linked-data';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static deletePermanently(
    params: {
      /** requestBody */
      body?: DeletePermanentlyDto;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/rpc/delete-permanently';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static markAsDeleted(
    params: {
      /** requestBody */
      body?: MarkAsDeletedDto;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/rpc/delete';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getAllDebugInfo(options: IRequestOptions = {}): Promise<DebuggableQuery[]> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/rpc/debug';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      axios(configs, resolve, reject);
    });
  }
}

export class EventsService {
  /**
   *
   */
  static pushEvent(
    params: {
      /** requestBody */
      body?: EventsControllerEvent;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/events/push';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static pushEvents(
    params: {
      /** requestBody */
      body?: any | null[];
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/events/push-many';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static areDbChangesEnabled(options: IRequestOptions = {}): Promise<boolean> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/events/db-changes-enabled';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static setDbChangesEnabled(
    params: {
      /** requestBody */
      body?: SetEventsEnabledRequest;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/events/db-changes-enabled';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static reloadEvents(options: IRequestOptions = {}): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/events/reload-events';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      axios(configs, resolve, reject);
    });
  }
}

export class AccessRolesService {
  /**
   *
   */
  static previewRoles(
    params: {
      /**  */
      roleIds: any | null[];
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<object[]> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/access-roles/role-matrix-setup/preview';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { roleIds: params['roleIds'] };

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getRoleList(options: IRequestOptions = {}): Promise<object[]> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/access-roles/role-matrix-setup';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static setRoleGlobalFlag(
    params: {
      /**  */
      roleId: string;
      /** requestBody */
      body?: SetRolesGlobalFlagDto;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/access-roles/role-matrix-setup/{roleId}/global-flag';
      url = url.replace('{roleId}', params['roleId'] + '');

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getUsersWithRole(
    params: {
      /**  */
      roleId: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<object[]> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/access-roles/role-matrix-setup/{roleId}/users';
      url = url.replace('{roleId}', params['roleId'] + '');

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getRoleMatrixForRoleSetup(
    params: {
      /**  */
      roleId: string;
      /**  */
      extendsRoleId: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<GetRoleMatrixForSetupResponse> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/access-roles/role-matrix-setup/{roleId}';
      url = url.replace('{roleId}', params['roleId'] + '');

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { extendsRoleId: params['extendsRoleId'] };

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static invalidateRoleCaches(options: IRequestOptions = {}): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/access-roles/invalidate';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static notifyLogicalStructureChanged(options: IRequestOptions = {}): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/access-roles/notify-logical-structure-changed';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static patchRolesBulk(
    params: {
      /** requestBody */
      body?: PatchRolesBulkRequestDto;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/access-roles/patch';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
}

export class NotifyService {
  /**
   *
   */
  static byEmail(
    params: {
      /** requestBody */
      body?: EmailDto;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/notify/by-email';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static contragentByEmail(
    params: {
      /** requestBody */
      body?: ContragentByEmailDto;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/notify/contragent-by-email';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static sendEmailOnly(
    params: {
      /**  */
      fromEmailId: string;
      /**  */
      to: object;
      /**  */
      cc: object;
      /**  */
      bcc: object;
      /**  */
      subject: string;
      /**  */
      text: string;
      /**  */
      html: string;
      /**  */
      fileAttachments: [];
      /**  */
      filestoreAttachments: string;
      /**  */
      repliedId: string;
      /**  */
      chatId: string;
      /** requestBody */
      body?: EmailInfoDto;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/notify/send-email-only';

      const configs: IRequestConfig = getConfigs('post', 'multipart/form-data', url, options);

      let data = params.body;
      data = new FormData();
      if (params['fromEmailId'] != null) {
        if (Object.prototype.toString.call(params['fromEmailId']) === '[object Array]') {
          for (const item of params['fromEmailId']) {
            data.append('fromEmailId', item as any);
          }
        } else {
          data.append('fromEmailId', params['fromEmailId'] as any);
        }
      }

      if (params['to'] != null) {
        if (Object.prototype.toString.call(params['to']) === '[object Array]') {
          for (const item of params['to']) {
            data.append('to', item as any);
          }
        } else {
          data.append('to', params['to'] as any);
        }
      }

      if (params['cc'] != null) {
        if (Object.prototype.toString.call(params['cc']) === '[object Array]') {
          for (const item of params['cc']) {
            data.append('cc', item as any);
          }
        } else {
          data.append('cc', params['cc'] as any);
        }
      }

      if (params['bcc'] != null) {
        if (Object.prototype.toString.call(params['bcc']) === '[object Array]') {
          for (const item of params['bcc']) {
            data.append('bcc', item as any);
          }
        } else {
          data.append('bcc', params['bcc'] as any);
        }
      }

      if (params['subject'] != null) {
        if (Object.prototype.toString.call(params['subject']) === '[object Array]') {
          for (const item of params['subject']) {
            data.append('subject', item as any);
          }
        } else {
          data.append('subject', params['subject'] as any);
        }
      }

      if (params['text'] != null) {
        if (Object.prototype.toString.call(params['text']) === '[object Array]') {
          for (const item of params['text']) {
            data.append('text', item as any);
          }
        } else {
          data.append('text', params['text'] as any);
        }
      }

      if (params['html'] != null) {
        if (Object.prototype.toString.call(params['html']) === '[object Array]') {
          for (const item of params['html']) {
            data.append('html', item as any);
          }
        } else {
          data.append('html', params['html'] as any);
        }
      }

      if (params['fileAttachments'] != null) {
        if (Object.prototype.toString.call(params['fileAttachments']) === '[object Array]') {
          for (const item of params['fileAttachments']) {
            data.append('fileAttachments', item as any);
          }
        } else {
          data.append('fileAttachments', params['fileAttachments'] as any);
        }
      }

      if (params['filestoreAttachments'] != null) {
        if (Object.prototype.toString.call(params['filestoreAttachments']) === '[object Array]') {
          for (const item of params['filestoreAttachments']) {
            data.append('filestoreAttachments', item as any);
          }
        } else {
          data.append('filestoreAttachments', params['filestoreAttachments'] as any);
        }
      }

      if (params['repliedId'] != null) {
        if (Object.prototype.toString.call(params['repliedId']) === '[object Array]') {
          for (const item of params['repliedId']) {
            data.append('repliedId', item as any);
          }
        } else {
          data.append('repliedId', params['repliedId'] as any);
        }
      }

      if (params['chatId'] != null) {
        if (Object.prototype.toString.call(params['chatId']) === '[object Array]') {
          for (const item of params['chatId']) {
            data.append('chatId', item as any);
          }
        } else {
          data.append('chatId', params['chatId'] as any);
        }
      }

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static byTelegram(
    params: {
      /** requestBody */
      body?: NotifyDto;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/notify/by-telegram';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static obtainTelegramLink(options: IRequestOptions = {}): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/notify/obtain-telegram-link';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static sendRegularMessage(
    params: {
      /** requestBody */
      body?: RegularMessageDto;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<RegularMessageResultDto> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/notify/regular-message';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static saveFcmToken(
    params: {
      /**  */
      type: string;
      /** requestBody */
      body?: SaveFcmTokenDto;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/notify/settings/fcm/token/{type}';
      url = url.replace('{type}', params['type'] + '');

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getNotificationsGroupedByCode(options: IRequestOptions = {}): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/notify/notifications/grouped/by-code';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static unsubscribeByUserIdByGet(
    params: {
      /**  */
      email: string;
      /**  */
      type: string;
      /**  */
      code: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<string> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/notify/notifications/unsubscribe';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { email: params['email'], type: params['type'], code: params['code'] };

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static unsubscribeByUserIdByPost(
    params: {
      /**  */
      email: string;
      /**  */
      type: string;
      /**  */
      code: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/notify/notifications/unsubscribe';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);
      configs.params = { email: params['email'], type: params['type'], code: params['code'] };

      axios(configs, resolve, reject);
    });
  }
}

export class NotificationsConfigService {
  /**
   *
   */
  static readEventTypes(options: IRequestOptions = {}): Promise<object[]> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/notify/config/event-types';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      axios(configs, resolve, reject);
    });
  }
}

export class AuthService {
  /**
   *
   */
  static login(
    params: {
      /** requestBody */
      body?: LoginDto;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/auth/login';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static loginV2(
    params: {
      /**  */
      sysTemplateCode: string;
      /** requestBody */
      body?: LoginDto;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/auth/login/{sysTemplateCode}';
      url = url.replace('{sysTemplateCode}', params['sysTemplateCode'] + '');

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static privilegedLogin(
    params: {
      /** requestBody */
      body?: PrivilegedLoginDto;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/auth/privileged-login';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static sendPasswordRecoveryEmail(
    params: {
      /** requestBody */
      body?: SendPasswordRecoverEmailDto;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/auth/send-password-email';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static resetPassword(
    params: {
      /** requestBody */
      body?: ResetPasswordDto;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/auth/password-reset';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static refreshTokens(
    params: {
      /** requestBody */
      body?: RefreshTokenDto;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<RefreshTokenResponseDto> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/auth/refresh-tokens';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getCurrentUser(options: IRequestOptions = {}): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/auth/me';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getServiceOrgHierarchyList(options: IRequestOptions = {}): Promise<object[]> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/auth/org-hierarchy';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getSessionParams(options: IRequestOptions = {}): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/auth/get-session-params';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getRoutesMenu(options: IRequestOptions = {}): Promise<object[]> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/auth/get-routes-menu-v3';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getRoutesMenuLegacy(options: IRequestOptions = {}): Promise<object[]> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/auth/get-routes-menu';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getUserOrgLink(
    params: {
      /** requestBody */
      body?: GetUserOrgLinkDto;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/auth/get-user-org-link';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static loginAsGuest(
    params: {
      /** requestBody */
      body?: GuestLinkToken;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<GuestLinkLoginResponse> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/auth/login-as-guest';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static searchGuests(
    params: {
      /** requestBody */
      body?: SearchGuestsDto;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/auth/search-guests';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static whoAmI(options: IRequestOptions = {}): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/auth/whoami';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      axios(configs, resolve, reject);
    });
  }
}

export class ActionsService {
  /**
   *
   */
  static executeAction(
    params: {
      /**  */
      subject: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/actions/{subject}';
      url = url.replace('{subject}', params['subject'] + '');

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      axios(configs, resolve, reject);
    });
  }
}

export class SmartFoldersService {
  /**
   *
   */
  static getFolders(
    params: {
      /** requestBody */
      body?: SmartFolderQueryDto;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<object[]> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/docflow-smart-folder';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
}

export class ReferenceDataService {
  /**
   *
   */
  static getReferenceData(
    params: {
      /** requestBody */
      body?: ReferenceDataQueryDto;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/reference_data';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
}

export class DocGenerationService {
  /**
   *
   */
  static generateDocument(
    params: {
      /** requestBody */
      body?: DocGenerationDto;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/document-generation';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static documentCreateBasedOn(
    params: {
      /** requestBody */
      body?: DocGenerationBasedOnDataDto;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/document-create-based-on';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static generateDocsFromFile(options: IRequestOptions = {}): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/generation-docs';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getArchiveXmlAct(
    params: {
      /** requestBody */
      body?: XMLDocActDto;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/archive-xml-act';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getArchiveXmlInvoice(
    params: {
      /** requestBody */
      body?: XMLDocInvoiceDto;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/archive-xml-invoice';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static handleBankStatementByXml(
    params: {
      /**  */
      fileAttachments: [];
      /** requestBody */
      body?: UploadBankStatementMultiXMLDto;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/upload-bank-statement';

      const configs: IRequestConfig = getConfigs('post', 'multipart/form-data', url, options);

      let data = params.body;
      data = new FormData();
      if (params['fileAttachments'] != null) {
        if (Object.prototype.toString.call(params['fileAttachments']) === '[object Array]') {
          for (const item of params['fileAttachments']) {
            data.append('fileAttachments', item as any);
          }
        } else {
          data.append('fileAttachments', params['fileAttachments'] as any);
        }
      }

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
}

export class DirectSqlService {
  /**
   *
   */
  static getOpeationInvoiceByInvoiceId(
    params: {
      /** requestBody */
      body?: InvoiceDto;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/direct-sql/get-operation-invoice-by-invoice-id';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getLinkedFiles(
    params: {
      /** requestBody */
      body?: InvoiceDto;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/direct-sql/get-linked-files';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
}

export class DocSharingService {
  /**
   *
   */
  static startDocSharing(
    params: {
      /** requestBody */
      body?: StartDocSharingDto;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/doc-sharing/start';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static cancelDocSharing(
    params: {
      /** requestBody */
      body?: CancelDocSharingDto;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<boolean> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/doc-sharing/cancel';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
}

export class SharingIntegrationService {
  /**
   *
   */
  static checkInn(
    params: {
      /** requestBody */
      body?: CheckInnRequestDto;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/sharing/integration/check-inn';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static sendRequest(
    params: {
      /** requestBody */
      body?: SendIntegrationRequestDto;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/sharing/integration/send-request';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static handleRequest(
    params: {
      /** requestBody */
      body?: SharingIntegrationRequestDto;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/sharing/integration';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static changeStatus(
    params: {
      /** requestBody */
      body?: ChangeSharingStatusDto;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/sharing/integration/change-status';

      const configs: IRequestConfig = getConfigs('put', 'application/json', url, options);

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static notifyCanceled(options: IRequestOptions = {}): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/sharing/integration/notify-canceled';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static acceptRequest(
    params: {
      /** requestBody */
      body?: SharingAcceptDto;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<string> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/sharing/integration/accept';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
}

export class PortalService {
  /**
   *
   */
  static invite(
    params: {
      /** requestBody */
      body?: PortalInviteDto;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/portal/invite';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static grant(
    params: {
      /** requestBody */
      body?: PortalGrantDto;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/portal/grant';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static registerByInvite(
    params: {
      /** requestBody */
      body?: PortalRegisterPayloadDto;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/portal/register';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getInviteInfo(
    params: {
      /**  */
      token: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<PortalInviteInfoResponse> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/portal/invite-info';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { token: params['token'] };

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getAvailableProjects(options: IRequestOptions = {}): Promise<GetPortalProjectsDto[]> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/portal/project-list';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static rejectContragent(
    params: {
      /** requestBody */
      body?: RejectContragentDto;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<RejectcontragentResponse> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/portal/reject-contragent';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
}

export class IntrospectionService {
  /**
   *
   */
  static listAll(options: IRequestOptions = {}): Promise<EntityBrieflyDto[]> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/introspection/entities/list';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      axios(configs, resolve, reject);
    });
  }
}

export class CommercialOfferCreateService {
  /**
   *
   */
  static create(
    params: {
      /** requestBody */
      body?: CommercialOfferCreateDto;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/commercialOfferCreate/Create';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static createAuto(
    params: {
      /** requestBody */
      body?: CommercialOfferCreateAutoDto;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<object[]> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/commercialOfferCreate/create-auto';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
}

export class AdminService {
  /**
   *
   */
  static readFullServiceMenu(options: IRequestOptions = {}): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/administration/full-service-menu';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static updateFullServiceMenu(
    params: {
      /** requestBody */
      body?: any | null[];
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/administration/full-service-menu';

      const configs: IRequestConfig = getConfigs('put', 'application/json', url, options);

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getUserList(options: IRequestOptions = {}): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/administration/user-list';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static saveUserList(
    params: {
      /** requestBody */
      body?: any | null[];
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/administration/user-list';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getUserById(
    params: {
      /**  */
      id: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/administration/user-list/{id}';
      url = url.replace('{id}', params['id'] + '');

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getOrgList(options: IRequestOptions = {}): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/administration/org-list';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static saveOrgList(
    params: {
      /** requestBody */
      body?: any | null[];
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/administration/org-list';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static copyServiceMenu(
    params: {
      /** requestBody */
      body?: CopyServiceMenuDto;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/administration/copy-service-menu';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getServiceRoles(options: IRequestOptions = {}): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/administration/service-roles';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getServiceRolesNew(
    params: {
      /**  */
      forSysUserId: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<object[]> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/administration/service-roles-new';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { forSysUserID: params['forSysUserId'] };

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static setRolesForUser(
    params: {
      /** requestBody */
      body?: SetRolesForUserDto;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/administration/set-roles-new';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getServiceMenu(
    params: {
      /** requestBody */
      body?: GetServiceMenuDto;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/administration/service-menu';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getRoleMetadata(
    params: {
      /** requestBody */
      body?: GetRoleMetadataDto;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/administration/get-role-metadata';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getServiceMetadataField(
    params: {
      /** requestBody */
      body?: GetServiceMetadataFieldDto;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/administration/get-service-metadata-field';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static updateAllSubscription(
    params: {
      /** requestBody */
      body?: UpdateAllSubscriptionDto;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/administration/update-all-subscription';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static fetchLogicalStructure(
    params: {
      /**  */
      serviceId: string;
      /**  */
      filtered: boolean;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<object[]> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/administration/logical-structure';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { serviceId: params['serviceId'], filtered: params['filtered'] };

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static saveLogicalStructure(
    params: {
      /** requestBody */
      body?: any | null[];
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/administration/logical-structure';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static fetchOrganizations(options: IRequestOptions = {}): Promise<object[]> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/administration/logical-structure/options';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      axios(configs, resolve, reject);
    });
  }
}

export class PgReportsService {
  /**
   *
   */
  static getFunctionsList(options: IRequestOptions = {}): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/administration/pg-reports/functions';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static introspectFunction(
    params: {
      /**  */
      name: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/administration/pg-reports/functions/{name}';
      url = url.replace('{name}', params['name'] + '');

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getPgReport(
    params: {
      /**  */
      id: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/administration/pg-reports/get/{id}';
      url = url.replace('{id}', params['id'] + '');

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      axios(configs, resolve, reject);
    });
  }
}

export class SuperAdminsService {
  /**
   *
   */
  static getStats(
    params: {
      /** requestBody */
      body?: GetOverallStatsDto;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/administration/super-admins/overall-stats';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static createLoginLink(
    params: {
      /** requestBody */
      body?: LoginLinkData;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/administration/super-admins/login-link';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static renderLoginRedirect(
    params: {
      /**  */
      code: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<string> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/administration/super-admins/login-link';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { code: params['code'] };

      axios(configs, resolve, reject);
    });
  }
}

export class ChatsService {
  /**
   *
   */
  static getMessageInfo(
    params: {
      /**  */
      messageId: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<ChatInfoDto> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/chats/message-info/{messageId}';
      url = url.replace('{messageId}', params['messageId'] + '');

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      axios(configs, resolve, reject);
    });
  }
}

export class SysReportTemplatesAdminService {
  /**
   *
   */
  static duplicateReportTemplate(
    params: {
      /** requestBody */
      body?: DuplicateSysReportTemplateDto;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<object[]> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/administration/sys-report-templates/duplicate';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
}

export class RegistrationService {
  /**
   *
   */
  static startRegistration(
    params: {
      /** requestBody */
      body?: StartRegistrationBodyDto;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/registration/start';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static setEmailVerified(
    params: {
      /** requestBody */
      body?: EmailVerifiedBodyDto;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/registration/email-verified';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
}

export class DataImportService {
  /**
   *
   */
  static extractColumns(
    params: {
      /** requestBody */
      body?: ExtractColumnsDto;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<ExtractColumnsResultDto> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/data-import/extract-columns';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static performImport(
    params: {
      /** requestBody */
      body?: PerformDataDto;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/data-import/perform-import';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
}

export class CommercialOfferCreateInvoiceService {
  /**
   *
   */
  static create(
    params: {
      /** requestBody */
      body?: CommercialOfferCreateInvoiceDto;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/commercialOfferCreateInvoice/Create';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
}

export class CommercialOfferMergeService {
  /**
   *
   */
  static create(
    params: {
      /** requestBody */
      body?: CommercialOfferMergeDto;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/CommercialOfferMerge/Create';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
}

export class CommercialOfferInvoiceRejectService {
  /**
   *
   */
  static getRejectInfo(
    params: {
      /** requestBody */
      body?: CommercialOfferInvoiceRejectInfoDto;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/commercialOfferInvoiceReject/GetRejectInfo';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static reject(
    params: {
      /** requestBody */
      body?: CommercialOfferInvoiceRejectDto;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/commercialOfferInvoiceReject/Reject';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
}

export class CommercialOfferInvoiceCommentService {
  /**
   *
   */
  static update(
    params: {
      /** requestBody */
      body?: CommercialOfferInvoiceCommentDto;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/commercialOfferInvoiceComment/Update';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
}

export class DocProcessService {
  /**
   *
   */
  static startProcess(
    params: {
      /** requestBody */
      body?: StartDocProcessDto;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/doc-process/start-process';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static finishStage(
    params: {
      /** requestBody */
      body?: StageFinishDto;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/doc-process/finish-stage';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static finishTask(
    params: {
      /** requestBody */
      body?: TaskFinishDto;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/doc-process/finish-task';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static finishProcess(
    params: {
      /** requestBody */
      body?: ProcessFinishDto;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/doc-process/finish-process';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static forceStopProcess(
    params: {
      /** requestBody */
      body?: ForceFinishDto;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/doc-process/force-stop-process';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static setDocState(
    params: {
      /** requestBody */
      body?: SetDocStateDto;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<object[]> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/doc-process/set-doc-state';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getAvailable(
    params: {
      /** requestBody */
      body?: GetAvailableProcessDto;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<object[]> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/doc-process/get-available';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getProcessInfo(
    params: {
      /** requestBody */
      body?: GetProcessInfoDto;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/doc-process/get-process-info';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getApprovementInfo(
    params: {
      /** requestBody */
      body?: GetApprovementInfoDto;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/doc-process/get-approvement-info';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getApprovalSheet(
    params: {
      /** requestBody */
      body?: GetDocumentApprovalHistoryDto;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/doc-process/get-approval-sheet';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getApprovalHistory(
    params: {
      /** requestBody */
      body?: GetDocumentApprovalHistoryDto;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/doc-process/get-approval-history';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
}

export class SysOptionService {
  /**
   *
   */
  static changeSysOptionTheme(options: IRequestOptions = {}): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/sysOption/ChangeTheme';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      axios(configs, resolve, reject);
    });
  }
}

export class NomenclatureService {
  /**
   *
   */
  static checkAndSaveNewNomenclature(
    params: {
      /** requestBody */
      body?: NomenclatureSyncListDto;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<NomenclatureResponse[]> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/nomenclature/check-and-save-new-nomenclature';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
}

export class AiService {
  /**
   *
   */
  static askChatGpt(
    params: {
      /**  */
      files: [];
      /**  */
      question: string;
      /**  */
      temperature: number;
      /**  */
      chatId: string;
      /**  */
      gptVersion: string;
      /** requestBody */
      body?: AskChatGPTDto;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/ai/ask-chat-gpt';

      const configs: IRequestConfig = getConfigs('post', 'multipart/form-data', url, options);

      let data = params.body;
      data = new FormData();
      if (params['files'] != null) {
        if (Object.prototype.toString.call(params['files']) === '[object Array]') {
          for (const item of params['files']) {
            data.append('files', item as any);
          }
        } else {
          data.append('files', params['files'] as any);
        }
      }

      if (params['question'] != null) {
        if (Object.prototype.toString.call(params['question']) === '[object Array]') {
          for (const item of params['question']) {
            data.append('question', item as any);
          }
        } else {
          data.append('question', params['question'] as any);
        }
      }

      if (params['temperature'] != null) {
        if (Object.prototype.toString.call(params['temperature']) === '[object Array]') {
          for (const item of params['temperature']) {
            data.append('temperature', item as any);
          }
        } else {
          data.append('temperature', params['temperature'] as any);
        }
      }

      if (params['chatId'] != null) {
        if (Object.prototype.toString.call(params['chatId']) === '[object Array]') {
          for (const item of params['chatId']) {
            data.append('chat_id', item as any);
          }
        } else {
          data.append('chat_id', params['chatId'] as any);
        }
      }

      if (params['gptVersion'] != null) {
        if (Object.prototype.toString.call(params['gptVersion']) === '[object Array]') {
          for (const item of params['gptVersion']) {
            data.append('gpt_version', item as any);
          }
        } else {
          data.append('gpt_version', params['gptVersion'] as any);
        }
      }

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static gptGetDataFromInvoiceFile(
    params: {
      /**  */
      files: [];
      /** requestBody */
      body?: RecognitionAskChatGPTDto;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/ai/ask-chat-gpt-recognition';

      const configs: IRequestConfig = getConfigs('post', 'multipart/form-data', url, options);

      let data = params.body;
      data = new FormData();
      if (params['files'] != null) {
        if (Object.prototype.toString.call(params['files']) === '[object Array]') {
          for (const item of params['files']) {
            data.append('files', item as any);
          }
        } else {
          data.append('files', params['files'] as any);
        }
      }

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static gptSendRequest(
    params: {
      /**  */
      files: [];
      /**  */
      data: string;
      /** requestBody */
      body?: UniversalAskChatGPTDto;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/ai/ask-chat-gpt-universal';

      const configs: IRequestConfig = getConfigs('post', 'multipart/form-data', url, options);

      let data = params.body;
      data = new FormData();
      if (params['files'] != null) {
        if (Object.prototype.toString.call(params['files']) === '[object Array]') {
          for (const item of params['files']) {
            data.append('files', item as any);
          }
        } else {
          data.append('files', params['files'] as any);
        }
      }

      if (params['data'] != null) {
        if (Object.prototype.toString.call(params['data']) === '[object Array]') {
          for (const item of params['data']) {
            data.append('data', item as any);
          }
        } else {
          data.append('data', params['data'] as any);
        }
      }

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static gptSendEmbeddingRequest(
    params: {
      /** requestBody */
      body?: EmbeddingsDto;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/ai/ask-chat-gpt-embedding';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
}

export class AiYandexService {
  /**
   *
   */
  static askYandexGpt(
    params: {
      /** requestBody */
      body?: AskYandexDto;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/ai-yandex/ask-yandex-gpt';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static askYandexChatGpt(
    params: {
      /** requestBody */
      body?: AskYandexDto;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/ai-yandex/ask-yandex-chat-gpt';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static recognizeSpeech(
    params: {
      /** requestBody */
      body?: SpeechYandexDto;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/ai-yandex/recognize-speech';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
}

export class MatchingService {
  /**
   *
   */
  static matching(
    params: {
      /** requestBody */
      body?: MatchingDto;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/matchingService/matching';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static matchingCommercialOfferAuto(
    params: {
      /** requestBody */
      body?: CommercialOfferAutoMatchDTO;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<object[]> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/matchingService/matching-commercial-offer-auto';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static matchingActDeliveryAuto(
    params: {
      /** requestBody */
      body?: ActDeliveryAutoMatchDTO;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<ActDeliveryRematchResult> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/matchingService/matching-act-delivery-auto';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
}

export class ScopeService {
  /**
   *
   */
  static createScope(
    params: {
      /** requestBody */
      body?: CreateScopeDTO;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/scope/create-scope';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
}

export class UserService {
  /**
   *
   */
  static getUserListBySysServiceOrgLink(options: IRequestOptions = {}): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/user/get-user-list';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      axios(configs, resolve, reject);
    });
  }
}

export class DocLinkService {
  /**
   *
   */
  static getLinkDocs(
    params: {
      /** requestBody */
      body?: DocLinkDto;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<object[]> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/doc-link/get-link-docs';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
}

export class UnirefService {
  /**
   * Список значений UNIREF по контракту
   */
  static query(
    params: {
      /** requestBody */
      body?: UniRefQueryDto;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<UniRefItemDto[]> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/uniref/query';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   * Создать или изменить значение списка
   */
  static save(
    params: {
      /** requestBody */
      body?: UniRefSaveDto;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<UniRefItemDto> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/uniref/save';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   * Значение по умолчанию для поля со списком
   */
  static defaultValue(
    params: {
      /** requestBody */
      body?: UniRefKeyDto;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<UniRefDefaultDto> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/uniref/default';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   * Мягкое удаление значений списка
   */
  static remove(
    params: {
      /** requestBody */
      body?: UniRefDeleteDto;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<UniRefDeleteResultDto> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/uniref/delete';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
}

export class InvoicePaymentService {
  /**
   *
   */
  static create(
    params: {
      /** requestBody */
      body?: InvoicePaymentCreateDto;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/invoice/payment/create';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static loadPaymentRegisterRow(
    params: {
      /** requestBody */
      body?: InvoicePaymentRegisterRowDto;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<object[]> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/invoice/payment/register-row';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
}

export class AiAgentService {
  /**
   *
   */
  static getMessages(
    params: {
      /**  */
      chatId: string;
      /**  */
      page?: number;
      /**  */
      pageSize?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<AiAgentMessagesPageDto> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/ai/agent/chats/{chatId}/messages';
      url = url.replace('{chatId}', params['chatId'] + '');

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { page: params['page'], pageSize: params['pageSize'] };

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static reviewMessage(
    params: {
      /**  */
      chatId: string;
      /**  */
      messageId: string;
      /** requestBody */
      body?: AiAgentMessageReviewRequestDto;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<{ ok: boolean }> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/ai/agent/chats/{chatId}/messages/{messageId}/review';
      url = url.replace('{chatId}', params['chatId'] + '');
      url = url.replace('{messageId}', params['messageId'] + '');

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static createResponse(
    params: {
      /** requestBody */
      body?: AiAgentResponseRequestDto;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/ai/agent/responses';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static streamResponse(
    params: {
      /** requestBody */
      body?: AiAgentResponseRequestDto;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/ai/agent/responses/stream';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static approve(
    params: {
      /**  */
      approvalId: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/ai/agent/approvals/{approvalId}/approve';
      url = url.replace('{approvalId}', params['approvalId'] + '');

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static reject(
    params: {
      /**  */
      approvalId: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/ai/agent/approvals/{approvalId}/reject';
      url = url.replace('{approvalId}', params['approvalId'] + '');

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      axios(configs, resolve, reject);
    });
  }
}

export interface RpcCallFunctionDto {
  /**  */
  fn: string;

  /**  */
  args: object;

  /**  */
  struct: object;

  /**  */
  options: object;
}

export interface RpcReadWithRefsDto {
  /**  */
  entity: string;

  /**  */
  options: object;
}

export interface RpcModifyDto {
  /**  */
  entity: object;

  /**  */
  data: object;

  /**  */
  options: object;
}

export interface ReadLinkedDataDto {
  /**  */
  schemaName?: string;

  /**  */
  tableNameChild?: string;

  /**  */
  tableNameLink?: string;

  /**  */
  fieldNameLinkParent?: string;

  /**  */
  fieldNameLinkChild?: string;

  /**  */
  parentId?: string;

  /**  */
  childSchemaName?: string;

  /**  */
  fieldNameSortChild?: string;

  /**  */
  additionalFieldsMainTable?: string[];

  /**  */
  isCheckType?: boolean;
}

export interface ReadLinkedDataResponse {
  /**  */
  value: string;

  /**  */
  name: string;

  /**  */
  label: string;

  /**  */
  parentId: string;

  /**  */
  linkId: string;
}

export interface DeletePermanentlyDto {
  /**  */
  tableInfo: object;

  /**  */
  ids: string[];
}

export interface MarkAsDeletedDto {
  /**  */
  tableInfo: object;

  /**  */
  ids: string[];
}

export interface DebuggableQuery {}

export interface EventsControllerEvent {
  /**  */
  code: string;

  /**  */
  id?: string;

  /**  */
  payload: object;

  /**  */
  timestamp?: object;
}

export interface SetEventsEnabledRequest {
  /**  */
  enabled: boolean;
}

export interface SetRolesGlobalFlagDto {
  /**  */
  isGlobal: boolean;
}

export interface GetRoleMatrixForSetupResponse {
  /**  */
  inheritedItems?: [];

  /**  */
  items: object[];
}

export interface PatchRoleItem {
  /**  */
  sys_logical_represent_id: string;

  /**  */
  can_access: string;

  /**  */
  can_create: string;

  /**  */
  can_modify: string;

  /**  */
  can_delete: string;

  /**  */
  is_single_choice_granted: boolean;
}

export interface PatchRolesBulkRequestDto {
  /**  */
  userIds: string[];

  /**  */
  roleItems: PatchRoleItem[];
}

export interface EmailDto {
  /**  */
  transport: object;
}

export interface EmailInfoDto {
  /**  */
  fromEmailId: string;

  /**  */
  to: object;

  /**  */
  cc: object;

  /**  */
  bcc: object;

  /**  */
  subject?: string;

  /**  */
  text?: string;

  /**  */
  html?: string;

  /**  */
  fileAttachments?: object[];

  /**  */
  filestoreAttachments?: string;

  /**  */
  repliedId?: string;

  /**  */
  chatId?: string;
}

export interface ContragentRecipient {
  /**  */
  linkName?: string;

  /**  */
  contragent_id?: string;

  /**  */
  email_to: string;

  /**  */
  additional_data?: object;
}

export interface ContragentByEmailDto {
  /**  */
  email: EmailInfoDto;

  /**  */
  recipients: ContragentRecipient[];

  /**  */
  redirect_to: string;

  /**  */
  time_to_expire?: number;

  /**  */
  origin: string;
}

export interface NotifyDto {}

export interface RegularMessageDto {
  /**  */
  toEmployeeId?: string;

  /**  */
  toPersonId?: string;

  /**  */
  transports: object[];

  /**  */
  subject: string;

  /**  */
  text: string;

  /**  */
  parent_id?: string;

  /**  */
  parent_table_name?: string;

  /**  */
  parent_name?: string;
}

export interface RegularMessageResultDto {
  /**  */
  email: object;

  /**  */
  telegram: object;

  /**  */
  errors: object[];
}

export interface SaveFcmTokenDto {
  /**  */
  token: string;

  /**  */
  deactivate?: boolean;
}

export interface LoginDto {
  /**  */
  login: string;

  /**  */
  password: string;
}

export interface PrivilegedLoginDto {
  /**  */
  login: string;
}

export interface SendPasswordRecoverEmailDto {
  /**  */
  email: string;

  /**  */
  linkTemplate: string;

  /**  */
  logoUrl?: string;

  /**  */
  isRegister?: boolean;
}

export interface ResetPasswordDto {
  /**  */
  token: string;

  /**  */
  newPassword: string;

  /**  */
  isRegister: boolean;
}

export interface RefreshTokenDto {
  /**  */
  refresh_token: string;
}

export interface RefreshTokenResponseDto {
  /**  */
  access_token: string;

  /**  */
  refresh_token: string;

  /**  */
  refresh_token_expires_at: Date;

  /**  */
  id: string;

  /**  */
  login: string;

  /**  */
  name: string;

  /**  */
  person_id: object;
}

export interface GetUserOrgLinkDto {
  /**  */
  sysUserId?: string;
}

export interface GuestLinkToken {
  /**  */
  token: string;
}

export interface GuestLinkLoginResponse {
  /**  */
  login: object;

  /**  */
  link: object;
}

export interface SearchGuestsDto {
  /**  */
  field: string;

  /**  */
  value: object;
}

export interface SmartFolderQueryDto {
  /**  */
  person_id: string;

  /**  */
  author_id: string;
}

export interface ReferenceDataQueryDto {
  /**  */
  query: string;

  /**  */
  schemaName: string;

  /**  */
  sqlFilter: string;

  /**  */
  tableName: string;

  /**  */
  columnName: object;

  /**  */
  limit?: number;
}

export interface DocGenerationDto {
  /**  */
  file: string;

  /**  */
  reportTemplate: object;

  /**  */
  sysParams: object;

  /**  */
  apiKey: string;

  /**  */
  extension: EnumDocGenerationDtoExtension;

  /**  */
  json?: string;

  /**  */
  data: object;

  /**  */
  simpleReport: object;
}

export interface DocGenerationBasedOnDataDto {
  /**  */
  sysParams: object;

  /**  */
  documentBaseType: EnumDocGenerationBasedOnDataDtoDocumentBaseType;

  /**  */
  documentCreatedType: EnumDocGenerationBasedOnDataDtoDocumentCreatedType;

  /**  */
  authorEmployee: object;

  /**  */
  data: object;

  /**  */
  saveDoc: boolean;
}

export interface XMLDocActDto {
  /**  */
  actId: string;

  /**  */
  isIncome: boolean;
}

export interface XMLDocInvoiceDto {
  /**  */
  invoiceId: string;

  /**  */
  usePaymentRegister: boolean;

  /**  */
  paymentRegisterId?: string;
}

export interface UploadBankStatementMultiXMLDto {
  /**  */
  fileAttachments: object[];
}

export interface InvoiceDto {
  /**  */
  id: string;
}

export interface StartDocSharingDto {
  /**  */
  ref: string;

  /**  */
  id: string;

  /**  */
  target_org_integration_id: string;
}

export interface CancelDocSharingDto {
  /**  */
  ref: string;

  /**  */
  id: string;
}

export interface CheckInnRequestDto {
  /**  */
  inn: string;

  /**  */
  service: string;
}

export interface SendIntegrationRequestDto {
  /**  */
  inn: string;

  /**  */
  gateway: string;
}

export interface SharingIntegrationRequestDto {
  /**  */
  self: object;

  /**  */
  target: object;

  /**  */
  access_token: string;

  /**  */
  expires_at: Date;

  /**  */
  version: string;

  /**  */
  service: string;
}

export interface ChangeSharingStatusDto {
  /**  */
  integration_id: string;

  /**  */
  status: object;
}

export interface SharingAcceptDto {
  /**  */
  permanentToken: string;
}

export interface PortalInviteDto {
  /**  */
  inn: string;

  /**  */
  email: string;

  /**  */
  contragent_id: object;

  /**  */
  project_id: object;

  /**  */
  grant: object[];
}

export interface PortalGrantDto {
  /**  */
  contragent_invite_id: string;

  /**  */
  project_id: object;

  /**  */
  grant: object[];
}

export interface PortalRegisterPayloadDto {
  /**  */
  email: string;

  /**  */
  head_full_name: string;

  /**  */
  inn: string;

  /**  */
  ogrn: string;

  /**  */
  org_name: string;

  /**  */
  password: string;

  /**  */
  phone?: string;

  /**  */
  token: string;
}

export interface PortalInviteInfoResponse {
  /**  */
  email?: string;

  /**  */
  inn?: string;

  /**  */
  ogrn?: string;

  /**  */
  org_name?: string;

  /**  */
  head_full_name?: string;

  /**  */
  phone?: string;
}

export interface GetPortalProjectsDto {
  /**  */
  name: string;

  /**  */
  value: string;

  /**  */
  label: string;

  /**  */
  id: string;

  /**  */
  contragent_sys_service_org_link_id: string;

  /**  */
  expires_at: number;
}

export interface RejectContragentDto {
  /**  */
  inviteId: string;
}

export interface RejectcontragentResponse {
  /**  */
  changed: boolean;
}

export interface EntityBrieflyDto {
  /**  */
  tableRef: string;

  /**  */
  comment?: string;

  /**  */
  name: string;
}

export interface CommercialOfferEntity {
  /**  */
  aud_when_sys_user_id?: object;

  /**  */
  author_employee_id?: object;

  /**  */
  commercial_offer_state?: string;

  /**  */
  commercial_offer_status_id?: object;

  /**  */
  contragent_id?: object;

  /**  */
  org_id?: object;

  /**  */
  date?: object;

  /**  */
  date_receive?: object;

  /**  */
  date_sent?: object;

  /**  */
  description?: string;

  /**  */
  email?: string;

  /**  */
  invoice_date?: object;

  /**  */
  invoice_number?: string;

  /**  */
  is_group?: boolean;

  /**  */
  name?: string;

  /**  */
  number?: string;

  /**  */
  parent_id?: object;

  /**  */
  payment_deferment?: number;

  /**  */
  prepayment_percentage?: number;

  /**  */
  project_id?: object;

  /**  */
  same_commercial_offer_id?: object;

  /**  */
  same_commercial_offer_name?: string;

  /**  */
  address?: string;

  /**  */
  sum_shipping?: number;

  /**  */
  rows?: object[];

  /**  */
  contragent_account_id?: string;
}

export interface CommercialOfferLinkEntity {
  /**  */
  co_marked?: boolean;

  /**  */
  commercial_offer_id?: object;

  /**  */
  description?: string;

  /**  */
  disable?: boolean;

  /**  */
  name?: string;

  /**  */
  nds_sum?: number;

  /**  */
  nds_type?: object;

  /**  */
  nomenclature_id?: object;

  /**  */
  price?: number;

  /**  */
  quantity?: number;

  /**  */
  request_quantity?: number;

  /**  */
  row_num?: number;

  /**  */
  sum?: number;

  /**  */
  sys_metadata_table_name?: string;

  /**  */
  table_row_id?: object;

  /**  */
  total?: number;

  /**  */
  unit_id?: object;

  /**  */
  is_delivery?: boolean;

  /**  */
  aud_when_matching?: number;
}

export interface RequestResponsibleEntity {
  /**  */
  aud_when_sys_user_id?: object;

  /**  */
  commercial_offer_id?: object;

  /**  */
  commercial_offer_link_option_id?: object;

  /**  */
  employee_id?: object;

  /**  */
  name?: string;

  /**  */
  request_id?: object;

  /**  */
  stage?: number;
}

export interface CommercialOfferCreateDto {
  /**  */
  commercial_offer: CommercialOfferEntity;

  /**  */
  commercial_offer_link_list: CommercialOfferLinkEntity[];

  /**  */
  request_responsible_list: RequestResponsibleEntity[];
}

export interface CommercialOfferCreateAutoDto {
  /**  */
  commercialOfferParentId: string;
}

export interface CopyServiceMenuDto {
  /**  */
  oldRoleId: string;

  /**  */
  newRoleId: string;
}

export interface SetRolesForUserDto {
  /**  */
  forSysUserId: string;

  /**  */
  roleIds: string[];

  /**  */
  appendMode?: boolean;
}

export interface GetServiceMenuDto {
  /**  */
  serviceRoleId: string;
}

export interface GetRoleMetadataDto {
  /**  */
  orgRoleLinkId: string;
}

export interface GetServiceMetadataFieldDto {
  /**  */
  sysMetadataId: string;

  /**  */
  sysServiceOrgRoleLinkMetadataLinkId: string;
}

export interface UpdateAllSubscriptionDto {
  /**  */
  all?: boolean;
}

export interface GetOverallStatsDto {
  /**  */
  interval?: string;

  /**  */
  sysSystemTemplateIds?: number[];
}

export interface LoginLinkData {
  /**  */
  sysUserId: string;
}

export interface ChatInfoDto {
  /**  */
  id: string;

  /**  */
  name: string;

  /**  */
  table_name: string;

  /**  */
  table_row_id: string;

  /**  */
  is_public: boolean;

  /**  */
  messages_count: number;

  /**  */
  docType?: string;
}

export interface DuplicateSysReportTemplateDto {
  /**  */
  sysSystemTemplateId?: number;

  /**  */
  fromSysServiceOrgLinkId?: string;

  /**  */
  toSysServiceOrgLinkIds?: string[];

  /**  */
  sysReportTemplateIds: string[];
}

export interface StartRegistrationBodyDto {
  /**  */
  randomString: string;

  /**  */
  name: string;

  /**  */
  email: string;

  /**  */
  phone?: string;

  /**  */
  password: string;
}

export interface EmailVerifiedBodyDto {
  /**  */
  session_id: string;
}

export interface ExtractColumnsDto {
  /**  */
  filestoreGuid: string;
}

export interface ExtractColumnsResultDto {
  /**  */
  columns: string[];

  /**  */
  sampleData: object[];
}

export interface PerformDataDto {
  /**  */
  fileGuid: string;

  /**  */
  tableName: string;

  /**  */
  schemaName: string;

  /**  */
  columnsGr: object[];

  /**  */
  paramsItem: object;

  /**  */
  isSave: boolean;
}

export interface InvoiceEntity {
  /**  */
  author_employee_id?: object;

  /**  */
  commercial_offer_id?: object;

  /**  */
  contract_id?: object;

  /**  */
  contragent_account_id?: object;

  /**  */
  contact_id?: object;

  /**  */
  contragent_id?: object;

  /**  */
  date?: object;

  /**  */
  sys_doc_state?: string;

  /**  */
  date_required_payment?: object;

  /**  */
  description?: string;

  /**  */
  invoice_status_id?: object;

  /**  */
  name?: string;

  /**  */
  number?: string;

  /**  */
  operation_description?: string;

  /**  */
  org_account_id?: object;

  /**  */
  org_id?: object;

  /**  */
  project_id?: object;

  /**  */
  sys_author_id?: object;

  /**  */
  sys_doc_type?: object;

  /**  */
  type?: number;

  /**  */
  sys_shared?: object;

  /**  */
  rows?: object[];

  /**  */
  prepayment_percentage?: number;

  /**  */
  payment_deferment?: number;

  /**  */
  is_matched_to_scan_file?: boolean;
}

export interface InvoiceRowEntity {
  /**  */
  budget_select_id?: object;

  /**  */
  date_to_pay?: object;

  /**  */
  description?: string;

  /**  */
  discount?: number;

  /**  */
  invoice_id?: object;

  /**  */
  invoice_row_status_id?: object;

  /**  */
  name?: string;

  /**  */
  nds_sum?: number;

  /**  */
  nds_type?: object;

  /**  */
  nomenclature_id?: object;

  /**  */
  operation_category_id?: object;

  /**  */
  price?: number;

  /**  */
  project_id?: object;

  /**  */
  quantity?: number;

  /**  */
  register_number?: string;

  /**  */
  request_row_id?: object;

  /**  */
  row_num?: number;

  /**  */
  sum?: number;

  /**  */
  sum_to_pay?: number;

  /**  */
  total?: number;

  /**  */
  unit_id?: object;

  /**  */
  sys_shared?: object;

  /**  */
  commercial_offer_link_id?: object;

  /**  */
  is_delivery?: boolean;
}

export interface CommercialOfferCreateInvoiceDto {
  /**  */
  employeeId: object;

  /**  */
  invoiceList: InvoiceEntity[];

  /**  */
  invoiceRowList: InvoiceRowEntity[];

  /**  */
  commercialOfferList: CommercialOfferEntity[];

  /**  */
  requestResponsibleList: RequestResponsibleEntity[];
}

export interface CommercialOfferMergeDto {
  /**  */
  commercialOfferIdList: string[];

  /**  */
  commercialOfferMergeId: string;

  /**  */
  textComment: string;

  /**  */
  authorEmployeeId: string;

  /**  */
  requestResponsibleNewList: RequestResponsibleEntity[];
}

export interface CommercialOfferInvoiceRejectInfoDto {
  /**  */
  invoiceId: string;
}

export interface CommercialOfferInvoiceRejectDto {
  /**  */
  invoiceIdList: string[];

  /**  */
  comment: string;

  /**  */
  rejectedAt?: string;
}

export interface CommercialOfferInvoiceCommentDto {
  /**  */
  commercialOfferId: string;

  /**  */
  description?: string;
}

export interface DeadlineList {
  /**  */
  id: string;

  /**  */
  deadline: number;
}

export interface StartDocProcessDto {
  /**  */
  documentType: string;

  /**  */
  docId: string;

  /**  */
  approvalProcessId: string;

  /**  */
  approvalProcessDeadline: number;

  /**  */
  stageDeadlineList: DeadlineList[];
}

export interface StageFinishDto {
  /**  */
  stageId?: string;

  /**  */
  status?: string;
}

export interface TaskFinishDto {
  /**  */
  docId?: string;

  /**  */
  status?: string;

  /**  */
  comment?: string;
}

export interface ProcessFinishDto {
  /**  */
  docIdList?: string[];

  /**  */
  status?: string;

  /**  */
  comment?: string;
}

export interface ForceFinishDto {
  /**  */
  processRunningId?: string;
}

export interface SetDocStateDto {
  /**  */
  idList: string[];

  /**  */
  docType: string;

  /**  */
  status: string;

  /**  */
  comment?: string;

  /**  */
  approvalProcessRunningId?: string;
}

export interface GetAvailableProcessDto {
  /**  */
  docType: string;

  /**  */
  docIds?: string[];
}

export interface GetProcessInfoDto {
  /**  */
  docType: string;

  /**  */
  docId?: string;

  /**  */
  approvalProcessId?: string;
}

export interface GetApprovementInfoDto {
  /**  */
  sysUserIds: string[];
}

export interface GetDocumentApprovalHistoryDto {
  /**  */
  docId: string;
}

export interface Nomenclature {
  /**  */
  id?: string;

  /**  */
  unitId: string;

  /**  */
  name: string;
}

export interface NomenclatureSyncListDto {
  /**  */
  nomenclatureList: Nomenclature[];
}

export interface NomenclatureResponse {
  /**  */
  id?: string;

  /**  */
  unitId: string;

  /**  */
  name: string;

  /**  */
  original_name: string;
}

export interface AskChatGPTDto {
  /**  */
  files?: object[];

  /**  */
  question: string;

  /**  */
  temperature: number;

  /**  */
  chat_id?: string;

  /**  */
  gpt_version?: string;
}

export interface RecognitionAskChatGPTDto {
  /**  */
  files: object[];
}

export interface UniversalAskChatGPTDto {
  /**  */
  files?: string[];

  /**  */
  data: string;
}

export interface EmbeddingsDto {
  /**  */
  data: string;
}

export interface YandexCompletionOptions {
  /**  */
  stream?: boolean;

  /**  */
  temperature?: number;

  /**  */
  maxTokens?: string;

  /**  */
  aiFolderId?: string;
}

export interface UserYandexGptMessage {
  /**  */
  role: string;

  /**  */
  text: string;
}

export interface AskYandexDto {
  /**  */
  model?: string;

  /**  */
  completionOptions: YandexCompletionOptions;

  /**  */
  chatId?: string;

  /**  */
  messages: UserYandexGptMessage[];
}

export interface SpeechYandexDto {
  /**  */
  file: string;
}

export interface MatchingDto {
  /**  */
  leftListId: string[];

  /**  */
  rightListId: string[];

  /**  */
  leftTableName: string;

  /**  */
  rightTableName: string;

  /**  */
  modelGPT?: string;

  /**  */
  searchInHistory?: boolean;
}

export interface CommercialOfferAutoMatchDTO {
  /**  */
  commercialOfferId?: string;
}

export interface ActDeliveryAutoMatchDTO {
  /**  */
  actId?: string;
}

export interface ActDeliveryRematchResult {
  /**  */
  totalRowCount?: number;

  /**  */
  matchedRowCount?: number;

  /**  */
  insertedRowCount?: number;

  /** Почему 0 совпадений: missing_header / no_matches / act_not_found / no_rows */
  skipReason?: string;
}

export interface CreateScopeOrg {
  /**  */
  name: string;

  /**  */
  fullName: string;

  /**  */
  inn: string;

  /**  */
  kpp: string;
}

export interface CreateScopeUser {
  /**  */
  email: string;

  /**  */
  login: string;

  /**  */
  surName: string;

  /**  */
  name: string;

  /**  */
  secName: string;

  /**  */
  phone: string;

  /**  */
  post: string;

  /**  */
  password: string;
}

export interface CreateScopeAccount {
  /**  */
  corrNum: string;

  /**  */
  address: string;

  /**  */
  bik: string;

  /**  */
  bank: string;

  /**  */
  accountNum: string;
}

export interface CreateScopeDTO {
  /**  */
  org: CreateScopeOrg;

  /**  */
  user: CreateScopeUser;

  /**  */
  account: CreateScopeAccount;

  /**  */
  createDemoData: boolean;

  /**  */
  originScopeId?: string;

  /**  */
  systemTemplateId?: number;

  /**  */
  addRecognitionBalance?: boolean;

  /**  */
  copyReportTemplate?: boolean;

  /**  */
  tarif: string;

  /**  */
  recognitionBalance?: number;

  /**  */
  limitUser: number;

  /**  */
  ignoreInn?: boolean;
}

export interface UniRefConditionDto {
  /** Поле отбора из настройки списка, например project_id */
  field: string;

  /** Значения поля; строка списка подходит, если совпало хотя бы одно. Числа сравниваются как строки */
  value: string[];
}

export interface UniRefQueryDto {
  /** Ключ списка, например pusk.commercial_offer.approvers */
  key: string;

  /**  */
  valueType: UniRefValueType;

  /** Текущий контекст отбора, все элементы через AND */
  condition?: UniRefConditionDto[];

  /** false — вернуть все строки ключа, без отбора по condition */
  applyCondition?: boolean;
}

export interface UniRefResolvedValueDto {
  /** Идентификатор сотрудника */
  id: string;

  /** ФИО и должность */
  name: string;

  /** Подпись для отображения */
  label: string;

  /** false — сотрудник уволен, удалён или это не основная должность: в согласование не попадёт */
  active: boolean;
}

export interface UniRefItemDto {
  /** Идентификатор значения списка */
  id: string;

  /** Наименование; null — в списке показывается само значение */
  name: string;

  /**  */
  valueType: UniRefValueType;

  /** Значение согласно valueType: employee_list — id сотрудников в порядке согласования, string — строка, number — число, date — дата ГГГГ-ММ-ДД */
  value: any | null;

  /** Условия отбора; null — значение подходит любому контексту */
  condition: UniRefConditionDto[];

  /** Расшифровка employee_list в порядке согласования; для других типов null */
  resolvedValue: UniRefResolvedValueDto[];

  /** Подпись для выпадающего списка: наименование или расшифровка значения */
  label: string;
}

export interface UniRefSaveDto {
  /** Есть — изменить значение, нет — создать новое */
  id?: string;

  /** Ключ списка, например pusk.commercial_offer.approvers */
  key: string;

  /**  */
  valueType: UniRefValueType;

  /** Наименование; пустое — в списке показывается само значение */
  name?: string;

  /** Значение согласно valueType: employee_list — id сотрудников в порядке согласования, string — строка, number — число, date — дата ГГГГ-ММ-ДД */
  value: any | null;

  /** Условия отбора; пусто — значение подходит любому контексту */
  condition?: UniRefConditionDto[];
}

export interface UniRefKeyDto {
  /** Ключ списка, например pusk.commercial_offer.payment_deferment */
  key: string;

  /**  */
  valueType: UniRefValueType;
}

export interface UniRefDefaultDto {
  /** Значение по умолчанию для текущего пользователя; null — подставлять нечего */
  value: any | null;
}

export interface UniRefDeleteDto {
  /** Идентификаторы значений списка */
  ids: string[];
}

export interface UniRefDeleteResultDto {
  /** Сколько значений помечено удалёнными */
  deleted: number;
}

export interface DocLinkDto {
  /** Таблица со схемой например: pusk.request  */
  table: string;

  /**  */
  excludeTableList?: string[];

  /**  */
  filters: object;
}

export interface InvoicePaymentStageDto {
  /**  */
  date: string;

  /**  */
  sum: number;

  /**  */
  percent?: number;

  /**  */
  isPaymentCalculate?: boolean;
}

export interface InvoicePaymentCreateDto {
  /**  */
  invoiceRowIds?: string[];

  /**  */
  invoiceIds?: string[];

  /**  */
  payments: InvoicePaymentStageDto[];

  /**  */
  accountType: string;

  /**  */
  accountId?: string;

  /** Расчётный счёт организации (platform.invoice.org_account_id). null — очистить. */
  orgAccountId?: string | null;

  /**  */
  currentEmployeeId?: string;

  /**  */
  statusIn?: string;
}

export interface InvoicePaymentRegisterRowDto {
  /**  */
  invoiceRowIdList?: string[];

  /**  */
  invoiceId?: string;
}

export interface AiAgentToolEventDto {
  /**  */
  name?: string;

  /**  */
  displayName: string;

  /**  */
  status: EnumAiAgentToolEventDtoStatus;

  /**  */
  arguments?: object;

  /**  */
  source?: string;
}

export interface AiAgentApprovalDto {
  /**  */
  approvalId: string;

  /**  */
  toolName?: string;

  /**  */
  displayName?: string;

  /**  */
  summary?: string;

  /**  */
  arguments?: object;
}

export interface AiAgentMessageDto {
  /**  */
  id: string;

  /**  */
  is_gpt: boolean;

  /**  */
  message?: string;

  /**  */
  temperature?: number;

  /**  */
  gpt_chat_id: string;

  /**  */
  aud_when_create: number;

  /**  */
  toolEvents: AiAgentToolEventDto[];

  /**  */
  pendingApproval?: AiAgentApprovalDto;

  /**  */
  review_is_good?: boolean | null;

  /**  */
  review_message?: string | null;
}

export interface AiAgentMessageReviewRequestDto {
  /**  */
  isGood: boolean | null;

  /**  */
  message?: string | null;
}

export interface AiAgentMessagesPageDto {
  /**  */
  data: AiAgentMessageDto[];

  /**  */
  page: number;

  /**  */
  pageSize: number;

  /**  */
  hasMore: boolean;
}

export interface AiAgentToolsDto {
  /**  */
  readonly?: boolean;

  /**  */
  allowedTools?: string[];
}

export interface AiAgentResponseRequestDto {
  /**  */
  message: string;

  /**  */
  chatId?: string;

  /**  */
  model?: string;

  /**  */
  temperature?: number;

  /**  */
  tools?: AiAgentToolsDto;

  /**  */
  debug?: boolean;
}
export enum EnumDocGenerationDtoExtension {
  'docx' = 'docx',
  'xlsx' = 'xlsx',
  'pdf' = 'pdf',
  'original' = 'original'
}
export enum EnumDocGenerationBasedOnDataDtoDocumentBaseType {
  'INVOICE' = 'INVOICE',
  'ACT' = 'ACT',
  'CONTRACT' = 'CONTRACT',
  'PAYMENT_REGISTER' = 'PAYMENT_REGISTER',
  'OTHER' = 'OTHER'
}
export enum EnumDocGenerationBasedOnDataDtoDocumentCreatedType {
  'INVOICE' = 'INVOICE',
  'ACT' = 'ACT',
  'CONTRACT' = 'CONTRACT',
  'PAYMENT_REGISTER' = 'PAYMENT_REGISTER',
  'OTHER' = 'OTHER'
}
export enum UniRefValueType {
  'employee_list' = 'employee_list',
  'string' = 'string',
  'number' = 'number',
  'date' = 'date'
}
export enum EnumAiAgentToolEventDtoStatus {
  'pending' = 'pending',
  'completed' = 'completed',
  'failed' = 'failed'
}
